// PDP Add-to-Cart Logic — Rose Edition
// build 2026-06-12T20 wording-servicelieferung-v7
// Bindet sich an <form class="pdp-add-form"> auf der Produktseite.
//
// Zwei Modi, am Markup erkannt:
//  - SKU-Modus: .pdp-price-opt trägt data-variant-id (+ data-selling-plan-id,
//    data-available; Preis-Strings vorformatiert aus Liquid: data-price-once-fmt /
//    data-price-sub-fmt / data-strike-fmt / data-save-once-fmt / data-save-sub-fmt —
//    JS rechnet und formatiert nichts, damit Währung/Markt immer stimmen).
//    Optionswechsel tauscht die Variante im Hidden-Input (1er = Hauptprodukt,
//    3er/5er = eigene Set-Produkte als native Bundles), Quantity bleibt 1.
//    Der Abo-Toggle setzt den Selling Plan der gewählten Option (Kaching
//    Subscriptions) und schaltet die Preisanzeige auf die Abo-Preise um.
//  - Legacy-Modus (ohne data-variant-id, z.B. Nachtruhe): Quantity 1/3/5
//    auf derselben Variante wie bisher.
//
// Submit geht via Ajax an /cart/add.js, danach cart:refresh → Drawer öffnet.

(function () {
  'use strict';

  const QTY_MAP = { '1mo': 1, '3mo': 3, '5mo': 5 };

  function init() {
    const form = document.querySelector('form.pdp-add-form');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('.pdp-qty-input');
    const sellingPlanInput = form.querySelector('.pdp-selling-plan-input');
    const buyBtn = form.querySelector('.pdp-buy-cta');
    const aboToggle = document.querySelector('#pdp-abo');
    const aboBox = document.querySelector('#pdp-abo-box');
    const intervalWrap = document.querySelector('#pdp-interval');
    const intervalThumb = intervalWrap ? intervalWrap.querySelector('.pdp-interval-thumb') : null;
    const intervalBtns = intervalWrap
      ? Array.prototype.slice.call(intervalWrap.querySelectorAll('.pdp-interval-opt'))
      : [];
    const INTERVAL_INDEX = { '1': 0, '3': 1, '5': 2 };
    const options = Array.prototype.slice.call(document.querySelectorAll('.pdp-price-opt'));
    if (!options.length) return;

    const skuMode = Boolean(options[0].dataset.variantId);
    // Gewähltes Lieferintervall ('1' | '3' | '5'); Default folgt der Setgrösse.
    let interval = null;

    function selectedOption() {
      return document.querySelector('.pdp-price-opt.selected') || options[0];
    }

    function aboActive() {
      return Boolean(aboToggle && aboToggle.classList.contains('checked'));
    }

    function planFor(opt, iv) {
      return opt.dataset['planM' + iv] || '';
    }

    function hasAnyPlan(opt) {
      return Boolean(planFor(opt, '1') || planFor(opt, '3') || planFor(opt, '5'));
    }

    // Hidden-Inputs, Abo-Box, Intervall-Picker, Preise und Kauf-Button angleichen
    function syncForm() {
      const opt = selectedOption();
      if (skuMode) {
        if (idInput && opt.dataset.variantId) idInput.value = opt.dataset.variantId;
        if (qtyInput) qtyInput.value = 1;
        if (interval === null || !planFor(opt, interval)) {
          interval = opt.dataset.defaultInterval || '1';
        }
        syncAboRow(opt);
        syncInterval(opt);
        if (sellingPlanInput) sellingPlanInput.value = aboActive() ? planFor(opt, interval) : '';
        syncPrices();
        syncBuyState(opt);
      } else {
        if (qtyInput && QTY_MAP[opt.dataset.opt]) qtyInput.value = QTY_MAP[opt.dataset.opt];
        if (sellingPlanInput) sellingPlanInput.value = '';
      }
    }

    // Die Servicelieferung-Box ist immer sichtbar; der Slider rechts wird
    // über die .abo-on-Klasse aktiv, sobald die Checkbox angehakt ist
    // (CSS dimmt ihn sonst und blockiert Klicks).
    function syncAboRow(opt) {
      if (aboBox) aboBox.classList.toggle('abo-on', aboActive());
    }

    // Slider: Thumb gleitet zur gewählten Position; Intervalle ohne Plan
    // (Option noch ohne Selling Plans) sind deaktiviert.
    function syncInterval(opt) {
      if (!intervalWrap) return;
      if (intervalThumb) {
        const idx = INTERVAL_INDEX[interval] || 0;
        intervalThumb.style.transform = 'translateX(' + (idx * 100) + '%)';
      }
      intervalBtns.forEach(function (b) {
        const iv = b.dataset.interval;
        b.disabled = !planFor(opt, iv);
        b.classList.toggle('is-active', iv === interval);
      });
    }

    function syncPrices() {
      const abo = aboActive();
      options.forEach(function (opt) {
        const el = opt.querySelector('.pdp-price-now');
        if (!el) return;
        const useSub = Boolean(abo && opt.dataset.priceSubFmt);
        if (opt.dataset.priceOnceFmt) {
          el.textContent = useSub ? opt.dataset.priceSubFmt : opt.dataset.priceOnceFmt;
        }
        // Grundpreis je kg (PAngV) passend zum gezeigten Preis, Einmalkauf oder Abo.
        const unitEl = opt.querySelector('.pdp-price-unit');
        if (unitEl) {
          const unit = useSub ? opt.dataset.unitSubFmt : opt.dataset.unitOnceFmt;
          unitEl.textContent = (unit || '').trim();
        }
        // Grüner Spare-Text links + durchgestrichener Vollpreis über dem Echtpreis.
        // Einmalkauf spart vs. Vollpreis-Anker (N× Einzelpreis), Abo zusätzlich
        // die 10% — ohne Ersparnis (1er ohne Abo) bleiben beide ausgeblendet.
        const saveEl = opt.querySelector('.pdp-price-save');
        const strikeEl = opt.querySelector('.pdp-price-strike');
        if (!saveEl || !strikeEl) return;
        const save = useSub ? opt.dataset.saveSubFmt : opt.dataset.saveOnceFmt;
        if (save) {
          saveEl.style.display = '';
          saveEl.textContent = 'Spare ' + save;
          strikeEl.style.display = '';
          strikeEl.textContent = opt.dataset.strikeFmt || '';
        } else {
          saveEl.style.display = 'none';
          strikeEl.style.display = 'none';
        }
      });
    }

    function syncBuyState(opt) {
      if (!buyBtn) return;
      const unavailable = opt.dataset.available === 'false';
      buyBtn.disabled = unavailable;
      buyBtn.textContent = unavailable ? 'Bald wieder verfügbar' : 'In den Warenkorb';
      // "Aktuell verfügbar"-Zeile darf dem Button nicht widersprechen
      const stockNote = document.querySelector('.pdp-stock');
      if (stockNote) stockNote.style.display = unavailable ? 'none' : '';
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        // Intervall folgt der Setgrösse (1er → monatlich, 3er → alle 3, 5er → alle 5);
        // die Kundin kann es danach im Picker frei umstellen.
        interval = opt.dataset.defaultInterval || interval;
        syncForm();
      });
    });

    if (aboToggle) {
      aboToggle.addEventListener('click', function () {
        aboToggle.classList.toggle('checked');
        syncForm();
      });
    }

    intervalBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        // Klick auf den Slider aktiviert die Servicelieferung gleich mit,
        // als hätte man den Haken gesetzt.
        if (aboToggle && !aboToggle.classList.contains('checked')) {
          aboToggle.classList.add('checked');
        }
        interval = b.dataset.interval;
        syncForm();
      });
    });

    // Vorauswahl per URL (?set=1mo|3mo|5mo) — gesetzt vom Set-Redirect im
    // Product Router, wenn Google-Feed-Links auf die Set-Produkte zeigen.
    try {
      var wantedSet = new URLSearchParams(window.location.search).get('set');
      if (wantedSet && QTY_MAP[wantedSet]) {
        var wantedOpt = options.filter(function (o) { return o.dataset.opt === wantedSet; })[0];
        if (wantedOpt) {
          options.forEach(function (o) { o.classList.remove('selected'); });
          wantedOpt.classList.add('selected');
          interval = wantedOpt.dataset.defaultInterval || interval;
        }
      }
    } catch (e) { /* alte Browser ohne URLSearchParams: Default bleibt */ }

    syncForm();

    // Form submit → Ajax add
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      // Abo gewählt, aber (noch) kein Selling Plan am Produkt: ehrlich blocken
      // statt still ohne Abo zu verkaufen.
      if (aboActive() && sellingPlanInput && !sellingPlanInput.value) {
        alert('Die Servicelieferung ist für dieses Paket in Kürze verfügbar. Bitte bestelle vorerst ohne Servicelieferung.');
        return;
      }
      const button = form.querySelector('.pdp-buy-cta');
      const originalText = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Wird hinzugefügt...';
      }
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.description || 'Fehler beim Hinzufügen');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        alert(err.message || 'Hinzufügen fehlgeschlagen');
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
